import { AnyAction } from "redux"
import {
  WEBHOOK_CALL,
  WEBHOOK_FAILURE,
  WEBHOOK_SUCCESS,
  WEBHOOK_FORM_CALL,
  WEBHOOK_FORM_FAILURE,
  WEBHOOK_FORM_SUCCESS
} from "./webhook-actions"

export interface webhookState {
  webhookList: {
    data: App.IWebhook[]
    loading: boolean
    error: string
  }
  webhookForm: {
    data: App.WebhookFormSchema
    loading: boolean
    error: string
  }
}

const INITIAL_STATE: webhookState = {
  webhookList: {
    data: [] as App.IWebhook[],
    loading: false,
    error: ""
  },
  webhookForm: {
    data: {
      formSchema: {},
      uiSchema: {},
      formData: {}
    } as App.WebhookFormSchema,
    loading: false,
    error: ""
  }
}

export default function webhookReducer(state: webhookState = INITIAL_STATE, action: AnyAction): webhookState {
  switch (action.type) {
    case WEBHOOK_CALL:
      return {
        ...state,
        webhookList: {
          ...state.webhookList,
          loading: true
        }
      }

    case WEBHOOK_SUCCESS:
      return {
        ...state,
        webhookList: {
          data: action.payload as App.IWebhook[],
          loading: false,
          error: ""
        }
      }

    case WEBHOOK_FAILURE:
      return {
        ...state,
        webhookList: {
          ...state.webhookList,
          loading: false,
          error: action.payload as string
        }
      }

    case WEBHOOK_FORM_CALL:
      return {
        ...state,
        webhookForm: {
          ...state.webhookForm,
          loading: true
        }
      }

    case WEBHOOK_FORM_SUCCESS:
      return {
        ...state,
        webhookForm: {
          data: action.payload as App.WebhookFormSchema,
          loading: false,
          error: ""
        }
      }

    case WEBHOOK_FORM_FAILURE:
      return {
        ...state,
        webhookForm: {
          ...state.webhookForm,
          loading: false,
          error: action.payload as string
        }
      }

    default:
      return state
  }
}
